import { render, staticRenderFns } from "./salesInstallments.vue?vue&type=template&id=52b43c22"
import script from "./salesInstallments.vue?vue&type=script&lang=js"
export * from "./salesInstallments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports